import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { WkLogoutComponent } from './wk-logout.component';
import { CoreModule } from '@alfresco/adf-core';

@NgModule({
  imports: [RouterModule, CommonModule, CoreModule],
  declarations: [WkLogoutComponent],
  exports: [WkLogoutComponent],
})
export class WkLogoutModule {}
